import Splide from "@splidejs/splide";

// Each block is set up on its own: a page can hold several carousels
// (e.g. offers above selected sailings on the homepage)
document.addEventListener("DOMContentLoaded", function () {
	document.querySelectorAll(".sailings-carousel-block").forEach(initCarousel);
});

function initCarousel(block) {
	const previewSlider = block.querySelector(".slider-preview");
	const detailSlider = block.querySelector(".slider-detail");
	const detailNav = block.querySelector(".detail-nav");

	if (!detailSlider) {
		return;
	}

	const count = detailSlider.querySelectorAll(".splide__slide").length;
	const single = count < 2;

	const detail = new Splide(detailSlider, {
		type: single ? "slide" : "loop",
		perPage: 1,
		perMove: 1,
		focus: "center",
		arrows: false,
		pagination: false,
		drag: !single,
	}).mount();

	// Nothing to navigate to: no thumbnails, arrows or counter
	if (single) {
		if (previewSlider) previewSlider.style.display = "none";
		if (detailNav) detailNav.style.display = "none";
		return;
	}

	if (detailNav) {
		const prevArrow = detailNav.querySelector(".arrow-prev");
		const nextArrow = detailNav.querySelector(".arrow-next");
		const slideCounter = detailNav.querySelector(".slide-count");

		if (prevArrow) {
			prevArrow.addEventListener("click", () => detail.go("<"));
		}

		if (nextArrow) {
			nextArrow.addEventListener("click", () => detail.go(">"));
		}

		if (slideCounter) {
			const updateCounter = () => {
				slideCounter.textContent = `${detail.index + 1}/${detail.length}`;
			};

			updateCounter();
			detail.on("move", updateCounter);
		}
	}

	if (previewSlider && window.innerWidth >= 992) {
		initPreview(previewSlider, detail, count);
	}
}

/**
 * Thumbnails show the slides after the big card, never the big card itself.
 *
 * With more slides than thumbnails the strip loops one step ahead of the
 * big card. With fewer, every slide fits so the strip stays put and the
 * current slide's thumbnail is hidden.
 */
function initPreview(previewSlider, detail, count) {
	const perPage = window.innerWidth <= 1200 ? 2 : 3;
	const loop = count > perPage;

	const preview = new Splide(previewSlider, {
		type: loop ? "loop" : "slide",
		start: loop ? 1 : 0,
		perPage: 3,
		perMove: 1,
		gap: 24,
		focus: 0,
		arrows: false,
		pagination: false,
		drag: false,
		breakpoints: {
			1200: {
				perPage: 2,
			},
		},
	}).mount();

	// Shortest way round the loop between two indexes, e.g. "+1" or "-2"
	const step = (from, to) => {
		const forward = (to - from + count) % count;
		return forward <= count / 2 ? `+${forward}` : `-${count - forward}`;
	};

	const markCurrent = (index) => {
		previewSlider.querySelectorAll(".splide__slide").forEach((slide) => {
			slide.classList.toggle("is-current", Number(slide.dataset.index) === index);
		});
	};

	if (loop) {
		detail.on("move", (newIndex, prevIndex) => {
			if (newIndex !== prevIndex) {
				preview.go(step(prevIndex, newIndex));
			}
		});
	} else {
		markCurrent(detail.index);
		detail.on("move", markCurrent);
	}

	// Event delegation also covers the loop's cloned slides
	const goToThumb = (event) => {
		const slide = event.target.closest(".splide__slide");
		if (!slide || slide.dataset.index === undefined) return;

		const target = Number(slide.dataset.index);
		if (target !== detail.index) {
			detail.go(step(detail.index, target));
		}
	};

	previewSlider.addEventListener("click", goToThumb);
	previewSlider.addEventListener("keydown", (event) => {
		if (event.key === "Enter" || event.key === " ") {
			event.preventDefault();
			goToThumb(event);
		}
	});
}
